const yup = require("yup");
const create = yup.object({
  programme: yup.string().required("Programme is a required field"),
  type: yup.string().required("Mode is a required field"),
  payment: yup.string().required("Payment is a required field"),
});

module.exports = { create };
